import { useEffect, useRef, useState } from "react";

/** Copia-negli-appunti con feedback effimero (``copied`` true per ~ms).
 *  Estratto (regola "ogni pulsante deve dare feedback", audit 2026-05-29)
 *  perche' W1 aggiunge 3 superfici di copia (SKU, tracking, email) che
 *  ripetevano lo stesso timer+cleanup+``catch``. Il ``catch`` e' voluto: in
 *  Electron la Clipboard API puo' mancare → nessun crash, feedback assente.
 *  Vive in ``shared/`` dal 2026-09-23: lo usano la card ordine e la sua cella
 *  Spedizione, che dentro la card non potrebbe importarlo senza un ciclo. */
export function useClipboardFeedback(ms = 1500) {
  const [copied, setCopied] = useState(false);
  const resetTimerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (resetTimerRef.current !== null) {
        window.clearTimeout(resetTimerRef.current);
        resetTimerRef.current = null;
      }
    };
  }, []);

  async function copy(text: string) {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      if (resetTimerRef.current !== null) window.clearTimeout(resetTimerRef.current);
      resetTimerRef.current = window.setTimeout(() => {
        resetTimerRef.current = null;
        setCopied(false);
      }, ms);
    } catch {
      // Clipboard API non disponibile in alcuni contesti Electron: silenzioso.
    }
  }

  return { copied, copy };
}
